import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "./LanguageContext"; // مسیر واقعی خودت
import { isSuperAdmin } from "../utils/token"; // ← جدید

const TEXTS = {
    fa: {
        dir: "rtl",
        font: "'IRANSansWeb', 'Vazirmatn', Tahoma, Geneva, sans-serif",
        company: "داشبورد مدیریت",
        home: "خانه",
        orders: "سفارشات",
        products: "محصولات",
        productPrice: "اعلامیه قیمت",
        grouping: "گروه‌بندی",
        profile: "پروفایل",
        employees: "کاربران",
        customers: "مشتریان",
        roleManagement: "نقش‌ها و دسترسی‌ها", // ← جدید
        settings: "تنظیمات", // ← جدید
        logout: "خروج",
    },
    ar: {
        dir: "rtl",
        font: "'IRANSansWeb', 'Vazirmatn', Tahoma, Geneva, sans-serif",
        company: "لوحة الإدارة",
        home: "الرئيسية",
        orders: "الطلبات",
        products: "المنتجات",
        productPrice: "إعلان السعر",
        grouping: "التصنيفات",
        profile: "الملف الشخصي",
        employees: "المستخدمون",
        customers: "العملاء",
        roleManagement: "الأدوار والصلاحيات", // ← جدید
        settings: "الإعدادات", // ← جدید
        logout: "تسجيل الخروج",
    },
};

function useWidth() {
    const [w, setW] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
    useEffect(() => {
        const fn = () => setW(window.innerWidth);
        window.addEventListener("resize", fn);
        return () => window.removeEventListener("resize", fn);
    }, []);
    return w;
}

// لیست پایه‌ی منو + آیتم «نقش‌ها و دسترسی‌ها» که فقط برای SuperAdmin اضافه می‌شود
function buildNavItems(t) {
    const baseItems = [
        { id: "dashboard", label: t.home, emoji: "🏠", path: "/dashboard" },
        { id: "orders", label: t.orders, emoji: "📋", path: "/order" },
        { id: "products", label: t.products, emoji: "📦", path: "/product" },
        { id: "productPrice", label: t.productPrice, emoji: "🏷️", path: "/ProductPrice" },
        { id: "grouping", label: t.grouping, emoji: "🗂️", path: "/GroupingManagement" },
        { id: "employees", label: t.employees, emoji: "🏪", path: "/employee" },
        { id: "customers", label: t.customers, emoji: "👥", path: "/customer" },
        { id: "profile", label: t.profile, emoji: "👤", path: "/profile" },
        { id: "settings", label: t.settings, emoji: "⚙️", path: "/Setting" },
    ];

    if (isSuperAdmin()) {
        baseItems.push({
            id: "roleManagement",
            label: t.roleManagement,
            emoji: "🔐",
            path: "/Role", // ← آدرس صفحه‌ی جدید
        });
    }

    return baseItems;
}

function Sidebar({ onLogout, t, isOpen, onToggle }) {
    const navigate = useNavigate();
    const location = useLocation();
    const navItems = buildNavItems(t); // ← به‌جای آرایه‌ی ثابت قبلی

    return (
        <div style={{
            width: isOpen ? 220 : 72, flexShrink: 0, background: "#fff",
            borderLeft: "1px solid #F0EDE8", display: "flex", flexDirection: "column",
            minHeight: "100%", position: "sticky", top: 0, alignSelf: "stretch",
            overflowY: "auto", overflowX: "hidden",
            transition: "width 0.2s ease",
        }}>
            <div style={{
                padding: isOpen ? "24px 20px 20px" : "24px 12px 20px",
                borderBottom: "1px solid #F0EDE8",
                display: "flex", alignItems: "center",
                justifyContent: isOpen ? "space-between" : "center",
                gap: 8,
            }}>
                {isOpen && (
                    <div style={{ fontSize: 11, color: "#9B9890", fontWeight: 600, letterSpacing: "0.05em" }}>
                        {t.company}
                    </div>
                )}
                <button
                    onClick={onToggle}
                    title={isOpen ? "بستن منو" : "باز کردن منو"}
                    style={{
                        width: 28, height: 28, borderRadius: 8,
                        border: "1px solid #F0EDE8", background: "#F8F7F2",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        cursor: "pointer", fontSize: 13, color: "#6366F1", flexShrink: 0,
                    }}
                >
                    {isOpen ? "«" : "»"}
                </button>
            </div>

            <div style={{ paddingTop: 8 }}>
                {navItems.map(n => {
                    const active = location.pathname === n.path;
                    return (
                        <button key={n.id} onClick={() => navigate(n.path)} title={!isOpen ? n.label : undefined} style={{
                            background: active ? "#EEF2FF" : "none",
                            border: "none",
                            borderRight: active ? "3px solid #6366F1" : "3px solid transparent",
                            cursor: "pointer", fontFamily: "inherit",
                            display: "flex", alignItems: "center", gap: 10,
                            justifyContent: isOpen ? "flex-start" : "center",
                            padding: isOpen ? "11px 20px" : "11px 8px", fontSize: 13,
                            fontWeight: active ? 700 : 500,
                            color: active ? "#6366F1" : "#555",
                            transition: "all 0.15s", width: "100%", textAlign: "right",
                        }}>
                            <span style={{ fontSize: 17 }}>{n.emoji}</span>
                            {isOpen && n.label}
                        </button>
                    );
                })}
            </div>

            <div style={{ flex: 1 }} />

            <div style={{ padding: isOpen ? "16px 20px" : "16px 8px", borderTop: "1px solid #F0EDE8" }}>
                <button onClick={onLogout} title={!isOpen ? t.logout : undefined} style={{
                    width: "100%", background: "#FEF2F2",
                    border: "1.5px solid #FECACA", borderRadius: 12,
                    padding: isOpen ? "10px 16px" : "10px 0", display: "flex", alignItems: "center",
                    justifyContent: isOpen ? "flex-start" : "center", gap: 8,
                    cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 600, color: "#DC2626",
                }}
                    onMouseEnter={e => e.currentTarget.style.background = "#FEE2E2"}
                    onMouseLeave={e => e.currentTarget.style.background = "#FEF2F2"}
                >
                    <span style={{ fontSize: 16 }}>🚪</span>
                    {isOpen && t.logout}
                </button>
            </div>
        </div>
    );
}

function BottomNav({ onLogout, t }) {
    const navigate = useNavigate();
    const location = useLocation();
    const navItems = buildNavItems(t); // ← به‌جای آرایه‌ی ثابت قبلی

    return (
        <nav style={{
            position: "fixed", bottom: 0, left: 0, right: 0,
            background: "rgba(255,255,255,0.96)", backdropFilter: "blur(12px)",
            borderTop: "1px solid #F0EDE8", display: "flex",
            justifyContent: "space-between", padding: "6px 4px 14px", zIndex: 300,
            overflowX: "auto",
        }}>
            {navItems.map(n => {
                const active = location.pathname === n.path;
                return (
                    <button key={n.path} onClick={() => navigate(n.path)} style={{
                        background: "none", border: "none", cursor: "pointer",
                        display: "flex", flexDirection: "column", alignItems: "center", gap: 1,
                        padding: "2px 2px", fontFamily: "inherit", flex: "1 1 0", minWidth: 0,
                    }}>
                        <div style={{
                            width: 28, height: 28, borderRadius: 9,
                            background: active ? "#EEF2FF" : "transparent",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            fontSize: 14, transition: "background 0.15s",
                        }}>{n.emoji}</div>
                        <span style={{
                            fontSize: 8.5, fontWeight: active ? 700 : 500, color: active ? "#6366F1" : "#B0ADA5",
                            whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%",
                        }}>
                            {n.label}
                        </span>
                    </button>
                );
            })}
            <button onClick={onLogout} style={{
                background: "none", border: "none", cursor: "pointer",
                display: "flex", flexDirection: "column", alignItems: "center", gap: 1,
                padding: "2px 2px", fontFamily: "inherit", flex: "1 1 0", minWidth: 0,
            }}>
                <div style={{
                    width: 28, height: 28, borderRadius: 9, background: "transparent",
                    display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14,
                }}>🚪</div>
                <span style={{ fontSize: 8.5, fontWeight: 500, color: "#DC2626", whiteSpace: "nowrap" }}>{t.logout}</span>
            </button>
        </nav>
    );
}

export default function Layout({ children }) {
    const width = useWidth();
    const isDesktop = width >= 1024;

    const { lang } = useLanguage();
    const t = TEXTS[lang] || TEXTS.fa;

    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const toggleSidebar = () => setIsSidebarOpen(prev => !prev);

    useEffect(() => {
        document.documentElement.dir = t.dir;
        document.documentElement.lang = lang;
    }, [lang, t]);

    const handleLogout = () => {
        window.location.href = "/login";
    };

    return (
        <>
            <style>{`
                *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
                @keyframes sk { 0%{background-position:100% 0} 100%{background-position:-100% 0} }
                ::-webkit-scrollbar { display: none; }
                html, body { background: #F8F7F2; }
            `}</style>
            <div style={{
                fontFamily: t.font,
                background: "#F8F7F2", minHeight: "100vh", direction: t.dir,
                display: "flex", flexDirection: isDesktop ? "row" : "column",
            }}>
                {isDesktop && (
                    <Sidebar
                        onLogout={handleLogout}
                        t={t}
                        isOpen={isSidebarOpen}
                        onToggle={toggleSidebar}
                    />
                )}
                <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", overflowX: "hidden" }}>
                    {children}
                </div>
                {!isDesktop && <BottomNav onLogout={handleLogout} t={t} />}
            </div>
        </>
    );
}